// removed by extract-text-webpack-plugin
module.exports = {"buttonDiscard":"src-components-Settings-SettingTextEditor-__styles__buttonDiscard--21JSD","characterCount":"src-components-Settings-SettingTextEditor-__styles__characterCount--1iXkF","approachingMaxChars":"src-components-Settings-SettingTextEditor-__styles__approachingMaxChars--3m7G5","exceedsMaxChars":"src-components-Settings-SettingTextEditor-__styles__exceedsMaxChars--3IWpa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Settings/SettingTextEditor/styles.css
// module id = 2005
// module chunks = 0